<template>
  <el-drawer v-model="drawerVisible" :title="title" size="66%">
    <div v-loading="loading" style="height: 95%; width: 100%">
      <div
        v-if="isShow && drawerVisible"
        ref="jsmind_container"
        class="g-jsmind-container"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </el-drawer>
</template>

<script>
import JsMind from 'jsmind'
import 'jsmind/style/jsmind.css'

export default {
  name: 'channels',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: undefined
    },
    expandLevel: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:visible'],
  data() {
    return {
      isShow: false,
      loading: true,
      jsmind_options: {
        editable: false,
        draggable: true,
        theme: 'greensea',
        mode: 'full',
        view: {
          engine: 'svg', // 思维导图各节点之间线条的绘制引擎
          hmargin: 10, // 思维导图距容器外框的最小水平距离
          vmargin: 10, // 思维导图距容器外框的最小垂直距离
          line_color: 'rgb(80,132,253)', // 思维导图线条的颜色
          node_overflow: 'wrap' // wrap hidden节点文本过长时的样式
        }
      },
      jsmind_data: {
        meta: {
          name: 'jsMind-tree',
          author: '',
          version: '0.2'
        },
        format: 'node_tree',
        data: undefined
      },
      jsmind_instance: null
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.loading = true
        if (val) {
          this.jsMindShow(val)
        } else {
          this.isShow = false
          this.loading = false
        }
      },
      immediate: true
    }
  },
  methods: {
    jsMindShow(data) {
      if (!data) {
        this.isShow = false
        return
      }
      this.isShow = true
      this.$nextTick(() => {
        if (!this.$refs.jsmind_container) return
        const options = { ...this.jsmind_options, container: this.$refs.jsmind_container }
        this.jsmind_instance = new JsMind(options)
        this.jsmind_instance.show({ ...this.jsmind_data, data: data })

        // 如果设置了展开级别，则按指定级别展开
        // if (this.expandLevel !== undefined) {
        //   this.jsmind_instance.expand_to_depth(this.expandLevel)
        // }
        this.loading = false
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style>
.g-jsmind-container {
  .theme-greensea {
    .root {
      background-color: rgba(29, 76, 210, 1);
      color: white;
      border-radius: 50px;
      font-size: 18px;
    }
    .selected {
      background-color: rgba(29, 76, 210, 1);
      color: #fff;
    }
    jmnode {
      background-color: rgba(29, 76, 210, 0.6);
      color: white;
      box-shadow: none;
      cursor: pointer;
      &:hover:not(.selected, .root) {
        background-color: rgba(29, 76, 210, 1);
      }
    }
    jmexpander {
      width: 14px;
      height: 14px;
      border-radius: 100%;
      line-height: 10px;
    }
  }
}
</style>
